import React from 'react';
import { Grid, Container, Typography, Box, Button, Card, CardContent } from '@mui/material';
import { useNavigate } from "react-router-dom";
import PricingCard from './PricingCard';

const pricingPlans = [
  {
    title: 'Basic',
    price: '₹1899/sqft',
    originalPrice: '₹1999',
    features: ['RCC framed structure', 'Basic materials', 'RCC foundation & roof'],
  },
  {
    title: 'Standard',
    price: '₹2099/sqft',
    originalPrice: '₹2299',
    features: ['Smart Home Automation', 'Organic Terrace Gardening', 'All Basic Features'],
  },
  {
    title: 'Premium',
    price: '₹2449/sqft',
    originalPrice: '₹2599',
    features: ['Granite flooring', 'Premium materials', 'All Standard Features'],
  },
];

const Pricing = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ backgroundColor: '#F5EEDC', minHeight: '100vh', color: '#183B4E', py: 6 }}>
      <Container maxWidth="lg">
        <Typography 
          variant="h3" 
          align="center" 
          gutterBottom 
          sx={{ color: '#27548A', fontWeight: '600', letterSpacing: '1px' }}
        >
          Pricing Plans
        </Typography>
        <Typography variant="h6" align="center" sx={{ color: '#555', mb: 4 }}>
          Choose a plan that fits your needs. Transparent pricing, no hidden costs.
        </Typography>

        <Grid container spacing={4} justifyContent="center" alignItems="stretch">
          {pricingPlans.map((plan, index) => (
            <Grid item xs={12} sm={6} md={4} key={index} sx={{ display: 'flex', justifyContent: 'center' }}>
              <PricingCard
                title={plan.title}
                price={plan.price}
                originalPrice={plan.originalPrice}
                features={plan.features}
              />
            </Grid>
          ))}
        </Grid>

        <Card sx={{ mt: 6, p: 4, borderRadius: '16px', boxShadow: 5, textAlign: 'center', backgroundColor: '#FFF' }}>
          <CardContent>
            <Typography variant="h4" sx={{ color: '#27548A', fontWeight: 'bold', mb: 2 }}>
              Why Choose Us?
            </Typography>
            <Typography variant="body1" sx={{ color: '#555', mb: 2 }}>
              <strong>CaRE Constructions</strong> provides transparent and competitive pricing with comprehensive material testing and foundational analysis.
            </Typography>
            <Typography variant="body1" sx={{ color: '#183B4E', fontWeight: 'bold', mt: 3 }}>
              Our Commitment:
            </Typography>
            <Typography variant="body1" sx={{ color: '#555' }}>
              ✔ Quality Material Testing Certificate for safety and durability
            </Typography>
            <Typography variant="body1" sx={{ color: '#555' }}>
              ✔ Soil Testing & Foundational Analysis for a strong base
            </Typography>
            <Typography variant="body1" sx={{ color: '#555' }}>
              ✔ 16-Year Structural Guarantee for long-term assurance
            </Typography>
            <Typography variant="h6" sx={{ color: '#27548A', fontWeight: 'bold', mt: 3 }}>
              Get a personalized estimate with our Construction Cost Calculator.
            </Typography>
          </CardContent>
        </Card>

        <Box display="flex" justifyContent="center" mt={4}>
          <Button
            variant="contained"
            sx={{ 
              backgroundColor: "#27548A", 
              color: "#fff", 
              px: 4, 
              py: 1.5,
              borderRadius: '30px',
              fontSize: '1.1rem',
              fontWeight: 'bold',
              transition: '0.3s',
              "&:hover": { backgroundColor: "#1e3b5a", transform: "scale(1.05)" }
            }}
            onClick={() => {
              navigate("/cost-calculator");
              setTimeout(() => {
                window.scrollTo({ top: 0, behavior: "smooth" });
              }, 100);
            }}
          >
            TRY COST CALCULATOR
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default Pricing;
